// extracted by mini-css-extract-plugin
export default {"faqSection":"styles_faqSection__f5Sto","faqContainer":"styles_faqContainer__YhKmH","title":"styles_title__Kjggj","hint":"styles_hint__mws9V"};